module.exports = __webpack_public_path__ + "d55e6525abc01138e9579ead98e20c5a.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/12_column_small_x1/public/games/coh_image_3.png
// module id = 308
// module chunks = 0